import { get } from "./apiService";

/**
 * Get all feature flags
 * @returns {Promise} All feature flags for web platform
 */
export const getAllFeatureFlags = async () => {
  try {
    const result = await get("/api/v2/feature-flags?platform=web");
    return result;
  } catch (err) {
    throw new Error(`Could not get feature flags: ${err.message}`);
  }
};

/**
 * Get a single feature flag by category and key
 * @param {string} category - "mainFeatures" or "settingsPage"
 * @param {string} key - Feature flag key (e.g., "buyCrypto", "profile")
 * @returns {Promise} Single feature flag data
 */
export const getFeatureFlagByKey = async (category, key) => {
  try {
    const result = await get(
      `/api/v2/feature-flags?category=${category}&key=${key}&platform=web`
    );
    return result;
  } catch (err) {
    throw new Error(`Could not get feature flag: ${err.message}`);
  }
};

/**
 * Get all feature flags by category
 * @param {string} category - "mainFeatures" or "settingsPage"
 * @returns {Promise} All feature flags in the category
 */
export const getFeatureFlagsByCategory = async (category) => {
  try {
    const result = await get(
      `/api/v2/feature-flags?category=${category}&platform=web`
    );
    return result;
  } catch (err) {
    throw new Error(`Could not get feature flags: ${err.message}`);
  }
};
